module.exports = __webpack_public_path__ + "img/characterAnime4.5a9b909b.png";